(() => {
  if (customElements.get('announcement-bar')) {
    return;
  }

  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.cookieKey = 'announcementBarHidden';
    }

    get activeClass() {
      return 'is-visible';
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    disconnectedCallback() {
      this.closeButton?.removeEventListener('click', this.close);
    }

    init() {
      this.closeButton = this.querySelector('[data-close-btn]');
      this.close = this.close.bind(this);

      this.show();
    }

    attachEvents() {
      this.closeButton?.addEventListener('click',this.close);
    }

    show() {
      const isHidden = getCookie(this.cookieKey) === 'true';

      if (isHidden) {
        this.remove();

        return;
      };

      this.classList.add(this.activeClass);

      updateCSSVariables();
    }

    close() {
      document.dispatchEvent(new CustomEvent('AnnouncementBar-before:hide'));

      this.classList.remove(this.activeClass);

      updateCSSVariables();

      const elementStyles = getComputedStyle(this);
      const hasTransition = elementStyles.transitionDuration && parseFloat(elementStyles.transitionDuration) > 0;
      const dispatchAfterHide = () => {
        document.dispatchEvent(new CustomEvent('AnnouncementBar-after:hide'));

        this.remove();
      };

      if (hasTransition) {
        this.addEventListener('transitionend', dispatchAfterHide, { once: true });
      } else {
        dispatchAfterHide();
      }

      setCookie(this.cookieKey, true, 1);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
})();
